import MForm from '@/components/form/index.vue';
import NDialog from '@/components/dialog/index.vue';
import MInfoWindow from '@/components/mInfoWindow/index.vue';
import MPopover from '@/components/mPopover/index.vue';

import { popContextmenu } from '@/components/contextmenu/utils';

import { isEmpty, isObject } from '@/utils/is';
import { useComponent } from '@/utils/utils';

import ctt from '@/utils/const/index';

import {
  getCD602AlgoConfig,
  getCD602AlgoParams,
  getCD602DeviceParams,
  getFR01DeviceData,
  getZX27AlgoParams,
  getZX27DeviceParams,
  setCD602AlgoConfig,
  setCD602AlgoParams,
  setCD602DeviceParams,
  setFR01DeviceParams,
  setZX27AlgoParams,
  setZX27DeviceParams
} from '@/api/deviceSetting';
import { getDeviceUpgradeParams, upgradeDevice } from '@/api/deviceUpgrade';
import { setDeviceCoordinate } from '@/layout/commonActions/setDeviceCoordinate';
import { getFr01BoxConfigBySn, setFr01BoxConfigBySn } from '@/api/devices';
import { isOnline } from '@/utils/deviceUtils/state';

export function deviceContextMenu(event, data) {
  const { sn, deviceType, runstate } = data;

  if (isEmpty(data) || isEmpty(sn) || isEmpty(deviceType)) return;

  popContextmenu({
    x: event.clientX,
    y: event.clientY,
    appendToBody: false,
    container: this.$refs.container,
    menu: [
      {
        text: this.$t('设备信息'),
        event: () => {
          openDeviceInfoPopover(data);
        }
      },
      {
        text: this.$t('参数调整'),
        show: () => isOnline(runstate),
        event: () => {
          if (deviceType === ctt.ZX27) {
            openZX27ParamsSettingWindow({ sn });
          } else {
            this.openParamsDialog(data);
          }
        }
      },
      {
        text: this.$t('算法参数调整'),
        show: () => this.authMenu['01021103'] && ctt.ZX27 === deviceType && isOnline(runstate),
        event: () => {
          openZX27AlgoParamsSettingWindow({ sn });
        }
      },
      {
        text: this.$t('内部参数调整'),
        show: () => this.authMenu['01021101'] && ctt.FR_01 === deviceType,
        event: () => {
          openFR01ParamsSettingsWindow({ sn });
        }
      },
      {
        text: this.$t('盒子参数调整'),
        show: () => this.authMenu['01021104'] && ctt.FR_01 === deviceType,
        event: () => {
          openFR01BoxParamsSettingsWindow({ sn });
        }
      }
    ]
  });
}

export function openInspectionMenu(event, data) {
  const { sn, deviceType } = data;

  if (isEmpty(data) || isEmpty(sn) || isEmpty(deviceType)) return;

  popContextmenu({
    x: event.clientX,
    y: event.clientY,
    appendToBody: true,
    container: document.body,
    menu: [
      {
        text: this.$t('设置算法参数'),
        event: () => {}
      },
      {
        text: this.$t('设置设备参数'),

        event: () => {
          openCD602ParamsSettingWindow({ sn });
        }
      }
    ]
  });
}

export function openCD602AlgoParamsSettingsWindow({ sn }) {
  const component = useComponent({
    components: { NDialog, MForm },
    data() {
      return {
        name: '',
        saveLoading: false,
        loading: false,
        formConfig: null
      };
    },
    methods: {
      setFormConfig(data) {
        const model = data;

        const { sn: _, ...rest } = model;

        this.formConfig = {
          config: {
            i18nPath: 'cotton',
            labelWidth: '183px',
            span: 12,
            options: Object.keys(rest).map(key => ({
              type: 'input',
              label: key,
              prop: key,
              attrs: {
                type: 'number'
              }
            }))
          },
          model
        };
      },
      async initParams() {
        try {
          this.loading = true;
          const res = await getCD602AlgoParams(sn);

          this.setFormConfig(res.data);
        } catch (error) {
          this.$message.error('获取算法参数失败');
          this.cancel();
          console.log(error);
        }
        this.loading = false;
      },
      async save() {
        try {
          this.saveLoading = true;

          await setCD602AlgoParams({ ...this.formConfig.model, sn });

          this.$message({
            type: 'success',
            message: this.$t('修改成功'),
            showClose: true
          });
        } catch (error) {
          this.$message({
            type: 'error',
            message: this.$t('修改失败'),
            showClose: true
          });
        } finally {
          this.saveLoading = false;

          this.cancel();
        }
      },
      cancel() {
        this.$refs.dialogRef.beforeClose();
      }
    },
    mounted() {
      this.initParams();
    },
    render() {
      return (
        <NDialog ref="dialogRef" width="70vw" title={this.$t('设置算法参数')}>
          <div
            style="min-height: 50vh;"
            v-loading={this.loading}
            element-loading-text={this.$t('数据加载中')}
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
          >
            {isEmpty(this.formConfig) ? null : <MForm ref="formRef" props={this.formConfig} />}
          </div>

          <div slot="footer">
            <el-button
              loading={this.loading || this.saveLoading}
              type="primary"
              onClick={this.save}
            >
              {this.$t('save')}
            </el-button>
            <el-button onClick={this.cancel}>{this.$t('取消')}</el-button>
          </div>
        </NDialog>
      );
    }
  });

  component.$mount();
}

export function openCD602AlgoConfigWindow({ sn }) {
  const component = useComponent({
    components: { NDialog, MForm },
    data() {
      return {
        name: '',
        saveLoading: false,
        loading: false,
        formConfig: null
      };
    },
    methods: {
      setFormConfig(data) {
        const model = data;

        const options = [
          {
            type: 'input',
            label: 'sensor1阈值',
            prop: 's1Th',
            attrs: {
              type: 'number'
            }
          },
          {
            type: 'input',
            label: 'sensor2阈值',
            prop: 's2Th',
            attrs: {
              type: 'number'
            }
          },
          {
            type: 'input',
            label: '零点偏移更新时间',
            prop: 'zeroResetOffset',
            attrs: {
              type: 'number'
            }
          },
          {
            type: 'input',
            label: '报警持续时间',
            prop: 'minimumAlarmTime',
            attrs: {
              type: 'number'
            }
          },
          {
            type: 'input',
            label: '稳定时间',
            prop: 'stableTime',
            attrs: {
              type: 'number'
            }
          },
          {
            type: 'input',
            label: '报警缓冲时间',
            prop: 'alarmBuffer',
            attrs: {
              type: 'number'
            }
          },
          {
            type: 'input',
            label: '数据比较缓冲时间',
            prop: 'dataBuffer',
            attrs: {
              type: 'number'
            }
          },
          {
            type: 'input',
            label: '通道比值下限',
            prop: 'ratioLowTh',
            attrs: {
              type: 'number'
            }
          },
          {
            type: 'input',
            label: '通道比值上限',
            prop: 'ratioHighTh',
            attrs: {
              type: 'number'
            }
          }
        ];

        this.formConfig = {
          config: {
            i18nPath: 'cotton',
            labelWidth: '183px',
            span: 12,
            options
          },
          model
        };
      },
      async initParams() {
        try {
          this.loading = true;
          const res = await getCD602AlgoConfig(sn);

          this.setFormConfig(res.data);
        } catch (error) {
          this.$message.error('获取算法配置失败');
          this.cancel();
          console.log(error);
        }
        this.loading = false;
      },
      async save() {
        try {
          this.saveLoading = true;

          await setCD602AlgoConfig({ ...this.formConfig.model, sn });

          this.$message({
            type: 'success',
            message: this.$t('修改成功'),
            showClose: true
          });
        } catch (error) {
          this.$message({
            type: 'error',
            message: this.$t('修改失败'),
            showClose: true
          });
        } finally {
          this.saveLoading = false;

          this.cancel();
        }
      },
      cancel() {
        this.$refs.dialogRef.beforeClose();
      }
    },
    mounted() {
      this.initParams();
    },
    render() {
      return (
        <NDialog ref="dialogRef" width="70vw" title={this.$t('设置算法配置')}>
          <div
            style="min-height: 50vh;"
            v-loading={this.loading}
            element-loading-text={this.$t('数据加载中')}
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
          >
            {isEmpty(this.formConfig) ? null : <MForm ref="formRef" props={this.formConfig} />}
          </div>

          <div slot="footer">
            <el-button
              loading={this.loading || this.saveLoading}
              type="primary"
              onClick={this.save}
            >
              {this.$t('save')}
            </el-button>
            <el-button onClick={this.cancel}>{this.$t('取消')}</el-button>
          </div>
        </NDialog>
      );
    }
  });

  component.$mount();
}

export function openCD602ParamsSettingWindow({ sn }) {
  const component = useComponent({
    components: { NDialog, MForm },
    data() {
      return {
        name: '',
        loading: false,
        saveLoading: false,
        clickCount: 0,
        timer: null,
        showHideParams: false,
        formConfig: {
          i18nPath: 'part',
          config: {
            i18nPath: 'cotton',
            labelWidth: '183px',
            span: 12,
            options: [
              {
                type: 'switch',
                label: '工作模式:',
                prop: 'workMode',
                attrs: {
                  // activeColor: '#13ce66',
                  // inactiveColor: '#ff4949',
                  activeValue: 0,
                  inactiveValue: 1,
                  activeText: '巡检模式',
                  inactiveText: '实时模式'
                }
              },
              {
                prop: 'fanStatus',
                label: '风扇状态:',
                type: 'radioGroup',
                dataKey: 'fanStatusList'
              },
              {
                prop: 'alarmLight',
                label: '报警灯:',
                type: 'radioGroup',
                dataKey: 'alarmList'
              },
              {
                prop: 'alarmSound',
                label: '报警声音:',
                type: 'radioGroup',
                dataKey: 'alarmList'
              },
              {
                prop: 'alarmVibrate',
                label: '报警震动:',
                type: 'radioGroup',
                dataKey: 'alarmList'
              },
              {
                prop: 'alarmEn',
                label: '屏蔽报警模式:',
                type: 'radioGroup',
                dataKey: 'alarmEnList',
                show: () => {
                  return this.showHideParams;
                }
              },
              {
                prop: 'simulateAlarm',
                label: '模拟报警:',
                type: 'radioGroup',
                dataKey: 'simulateAlarmList',
                show: () => {
                  return this.showHideParams;
                }
              }
            ]
          },
          model: {
            sn,
            alarmLight: 0,
            alarmSound: 0,
            alarmVibrate: 0,
            fanStatus: 0,
            workMode: 0,
            alarmEn: '',
            simulateAlarm: ''
          },
          dataSource: {
            fanStatusList: [
              {
                label: '停止',
                value: 0
              },
              {
                label: '开启',
                value: 1
              },
              {
                label: '故障',
                value: 2
              }
            ],
            alarmList: [
              {
                label: '关闭',
                value: 0
              },
              {
                label: '开启',
                value: 1
              }
            ],
            alarmEnList: [
              {
                label: '正常',
                value: 0
              },
              {
                label: '屏蔽',
                value: 1
              }
            ],
            simulateAlarmList: [
              {
                label: '停止',
                value: 0
              },
              {
                label: '开启',
                value: 1
              }
            ]
          }
        }
      };
    },
    methods: {
      async initParams() {
        try {
          this.loading = true;
          const res = await getCD602DeviceParams({ sn });

          Object.assign(this.formConfig.model, res.data);
        } catch (error) {
          this.$message.error('获取设备参数失败');
          this.cancel();
          console.log(error);
        }
        this.loading = false;
      },
      async save() {
        try {
          this.saveLoading = true;

          await setCD602DeviceParams({ ...this.formConfig.model, sn });

          this.$message({
            type: 'success',
            message: this.$t('修改成功'),
            showClose: true
          });
        } catch (error) {
          console.log(error);

          this.$message({
            type: 'error',
            message: this.$t('修改失败'),
            showClose: true
          });
        } finally {
          this.saveLoading = false;

          this.cancel();
        }
      },
      handleClick() {
        clearTimeout(this.timer);

        this.clickCount++;

        if (this.clickCount > 7) {
          // 屏蔽报警模式 alarmEn 0-正常 1-屏蔽

          this.showHideParams = true;
          this.formConfig.model.alarmEn = 0;
        }

        this.timer = setTimeout(() => {
          this.clickCount = 0;
        }, 300);
      },
      cancel() {
        this.$refs.dialogRef.beforeClose();
      }
    },
    mounted() {
      this.initParams();
    },
    render() {
      return (
        <NDialog ref="dialogRef" width="70vw" title={this.$t('设置设备参数')}>
          <div slot="title">
            <span class="el-dialog__title" onClick={this.handleClick}>
              {this.$t('设置设备参数')}
            </span>
          </div>

          <div
            style="min-height: 50vh;"
            v-loading={this.loading}
            element-loading-text={this.$t('数据加载中')}
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
          >
            <MForm ref="formRef" props={this.formConfig} />
          </div>

          <div slot="footer">
            <el-button
              loading={this.loading || this.saveLoading}
              type="primary"
              onClick={this.save}
            >
              {this.$t('save')}
            </el-button>
            <el-button onClick={this.cancel}>{this.$t('取消')}</el-button>
          </div>
        </NDialog>
      );
    }
  });

  component.$mount();
}

export function openZX27ParamsSettingWindow({ sn }) {
  const component = useComponent({
    components: { NDialog, MForm },
    data() {
      return {
        name: '',
        loading: false,
        saveLoading: false,
        clickCount: 0,
        timer: null,
        showHideParams: false,
        formConfig: {
          i18nPath: 'part',
          config: {
            i18nPath: 'cotton',
            labelWidth: '183px',
            span: 24,
            options: [
              {
                prop: 'pumpStatus',
                label: '气泵状态:',
                type: 'radioGroup',
                dataKey: 'pumpStatusList'
              },
              {
                prop: 'alarmLight',
                label: '报警灯:',
                type: 'radioGroup',
                dataKey: 'alarmList'
              },
              {
                prop: 'alarmSound',
                label: '报警声音:',
                type: 'radioGroup',
                dataKey: 'alarmList'
              },
              {
                span: 10,
                prop: 'cottonTransTime',
                label: '棉花输送到喷码机时间:',
                type: 'input',
                attrs: {
                  type: 'number'
                },
                slots: {
                  append: () => {
                    return <span>秒</span>;
                  }
                }
              },
              {
                prop: 'alarmEn',
                label: '屏蔽报警模式:',
                type: 'radioGroup',
                dataKey: 'alarmEnList',
                show: () => {
                  return this.showHideParams;
                }
              },
              {
                prop: 'simulateAlarm',
                label: '模拟报警:',
                type: 'radioGroup',
                dataKey: 'simulateAlarmList',
                show: () => {
                  return this.showHideParams;
                }
              }
            ]
          },
          model: {
            sn,
            pumpStatus: 0,
            alarmLight: 0,
            alarmSound: 0,
            cottonTransTime: 0,
            alarmEn: '',
            simulateAlarm: ''
          },
          dataSource: {
            pumpStatusList: [
              {
                label: '停止',
                value: 0
              },
              {
                label: '开启',
                value: 1
              },
              {
                label: '故障',
                value: 2
              }
            ],
            alarmList: [
              {
                label: '关闭',
                value: 0
              },
              {
                label: '开启',
                value: 1
              }
            ],
            alarmEnList: [
              {
                label: '正常',
                value: 0
              },
              {
                label: '屏蔽',
                value: 1
              }
            ],
            simulateAlarmList: [
              {
                label: '停止',
                value: 0
              },
              {
                label: '开启',
                value: 1
              }
            ]
          }
        }
      };
    },
    methods: {
      async initParams() {
        try {
          this.loading = true;
          const res = await getZX27DeviceParams({ sn });

          Object.assign(this.formConfig.model, res.data);
        } catch (error) {
          this.$message.error('获取设备参数失败');
          this.cancel();
          console.log(error);
        }
        this.loading = false;
      },
      async save() {
        try {
          this.saveLoading = true;

          await setZX27DeviceParams({ ...this.formConfig.model, sn });

          this.$message({
            type: 'success',
            message: this.$t('修改成功'),
            showClose: true
          });
        } catch (error) {
          console.log(error);

          this.$message({
            type: 'error',
            message: this.$t('修改失败'),
            showClose: true
          });
        } finally {
          this.saveLoading = false;

          this.cancel();
        }
      },
      handleClick() {
        clearTimeout(this.timer);

        this.clickCount++;

        if (this.clickCount > 7) {
          // 屏蔽报警模式 alarmEn 0-正常 1-屏蔽

          this.showHideParams = true;
          this.formConfig.model.alarmEn = 0;
        }

        this.timer = setTimeout(() => {
          this.clickCount = 0;
        }, 300);
      },
      cancel() {
        this.$refs.dialogRef.beforeClose();
      }
    },
    mounted() {
      this.initParams();
    },
    render() {
      return (
        <NDialog ref="dialogRef" width="70vw" title={this.$t('设置设备参数')}>
          <div slot="title">
            <span class="el-dialog__title" onClick={this.handleClick}>
              {this.$t('设置设备参数')}
            </span>
          </div>

          <div
            style="min-height: 50vh;"
            v-loading={this.loading}
            element-loading-text={this.$t('数据加载中')}
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
          >
            <MForm ref="formRef" props={this.formConfig} />
          </div>

          <div slot="footer">
            <el-button
              loading={this.loading || this.saveLoading}
              type="primary"
              onClick={this.save}
            >
              {this.$t('save')}
            </el-button>
            <el-button onClick={this.cancel}>{this.$t('取消')}</el-button>
          </div>
        </NDialog>
      );
    }
  });

  component.$mount();
}

export function openZX27AlgoParamsSettingWindow({ sn }) {
  const component = useComponent({
    components: { NDialog, MForm },
    data() {
      return {
        name: '',
        saveLoading: false,
        loading: false,
        formConfig: null
      };
    },
    methods: {
      setFormConfig(data) {
        const model = data;

        const { sn: _, ...rest } = model;

        this.formConfig = {
          config: {
            i18nPath: 'cotton',
            labelWidth: '183px',
            span: 12,
            options: Object.keys(rest).map(key => ({
              type: 'input',
              label: key,
              prop: key,
              attrs: {
                type: 'number'
              }
            }))
          },
          model
        };
      },
      async initParams() {
        try {
          this.loading = true;
          const res = await getZX27AlgoParams(sn);

          this.setFormConfig(res.data);
        } catch (error) {
          this.$message.error('获取算法参数失败');
          this.cancel();
          console.log(error);
        }
        this.loading = false;
      },
      async setAlgoParams() {
        try {
          await setZX27AlgoParams({ ...this.formConfig.model, sn });

          this.$message({
            type: 'success',
            message: this.$t('修改成功'),
            showClose: true
          });
        } catch (error) {
          this.$message({
            type: 'error',
            message: this.$t('修改失败'),
            showClose: true
          });
          console.log(error);
        }
      },
      async save() {
        try {
          this.saveLoading = true;

          await this.setAlgoParams();
        } catch (error) {
          console.log(error);
        } finally {
          this.saveLoading = false;

          this.cancel();
        }
      },
      cancel() {
        this.$refs.dialogRef.beforeClose();
      }
    },
    mounted() {
      this.initParams();
    },
    render() {
      return (
        <NDialog ref="dialogRef" width="70vw" title={this.$t('设置算法参数')}>
          <div
            style="min-height: 50vh;"
            v-loading={this.loading}
            element-loading-text={this.$t('数据加载中')}
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
          >
            {isEmpty(this.formConfig) ? null : <MForm ref="formRef" props={this.formConfig} />}
          </div>

          <div slot="footer">
            <el-button
              loading={this.loading || this.saveLoading}
              type="primary"
              onClick={this.save}
            >
              {this.$t('save')}
            </el-button>
            <el-button onClick={this.cancel}>{this.$t('取消')}</el-button>
          </div>
        </NDialog>
      );
    }
  });

  component.$mount();
}

export function openFireDetectionMenu(event, data) {
  const { sn } = data;

  popContextmenu({
    x: event.clientX,
    y: event.clientY,
    appendToBody: true,
    container: document.body,
    menu: [
      {
        text: this.$t('设置设备参数'),
        event: () => {
          openFR01ParamsSettingsWindow({ sn });
        }
      }
    ]
  });
}

export function openFR01ParamsSettingsWindow({ sn }) {
  const component = useComponent({
    components: { NDialog, MForm },
    data() {
      return {
        name: '',
        loading: false,
        saveLoading: false,
        rawData: null,
        formConfig: {
          i18nPath: 'part',
          config: {
            i18nPath: 'cotton',
            labelWidth: '183px',
            span: 12,
            options: [
              {
                type: 'switch',
                label: '自动发送报警状态:',
                prop: 'autoSendAlarm',
                attrs: {
                  // activeColor: '#13ce66',
                  // inactiveColor: '#ff4949',
                  activeValue: '0',
                  inactiveValue: '1',
                  activeText: '自动',
                  inactiveText: '不自动'
                }
              },
              {
                prop: 'autoSendAlarmCount',
                label: '循环发送报警次数:',
                type: 'input',
                attrs: {
                  type: 'number',
                  min: 1,
                  max: 30
                }
              },
              {
                prop: 'autoSendAlarmInterval',
                label: '发送报警状态间隔:',
                type: 'select',
                dataKey: 'autoSendAlarmIntervalOptions'
              },
              {
                type: 'input',
                label: '站号地址:',
                prop: 'stationNumber',
                attrs: {
                  min: 1,
                  max: 247,
                  type: 'number'
                }
              },
              {
                type: 'switch',
                label: '自动发送报警状态:',
                prop: 'autoReset',
                attrs: {
                  // activeColor: '#13ce66',
                  // inactiveColor: '#ff4949',
                  activeValue: '1',
                  inactiveValue: '2',
                  activeText: '自动',
                  inactiveText: '不自动'
                }
              },
              {
                prop: 'baudRate',
                label: '波特率:',
                type: 'select',
                dataKey: 'baudRateList'
              },
              {
                prop: 'sensitivity',
                label: '灵敏度:',
                type: 'select',
                dataKey: 'sensitivityList'
              },
              {
                prop: 'autoResetTime',
                label: '火警自复位时间:',
                type: 'input',
                attrs: {
                  type: 'number',
                  min: 1,
                  max: 250,
                  placeholder: '请输入1-250秒'
                }
              }
            ]
          },
          model: {
            sn,
            autoSendAlarm: '1',
            autoSendAlarmCount: '1',
            autoSendAlarmInterval: '500',
            stationNumber: '1',
            autoReset: '1',
            baudRate: '9600',
            sensitivity: '1',
            autoResetTime: '1'
          },
          dataSource: {
            autoSendAlarmIntervalOptions: [
              {
                label: '500ms',
                value: '500'
              },
              {
                label: '1000ms',
                value: '1000'
              },
              {
                label: '2000ms',
                value: '2000'
              }
            ],
            baudRateList: [
              {
                label: '9600',
                value: '0'
              },
              {
                label: '19200',
                value: '1'
              },
              {
                label: '38400',
                value: '2'
              },
              {
                label: '115200',
                value: '3'
              },
              {
                label: '256000',
                value: '4'
              }
            ],
            sensitivityList: [
              {
                label: '一级',
                value: '1'
              },
              {
                label: '二级',
                value: '2'
              },
              {
                label: '三级',
                value: '3'
              },
              {
                label: '四级',
                value: '4'
              }
            ]
          },
          rules: {
            autoSendAlarmCount: [
              {
                required: true,
                validator: (_, value, callback) => {
                  if (!value) {
                    callback(this.$t('请输入循环发送报警次数'));
                  } else if (value > 30 || value < 1) {
                    callback(this.$t('循环发送报警次数必须在1-30之间'));
                  } else {
                    callback();
                  }
                },
                trigger: 'blur'
              }
            ],
            autoResetTime: [
              {
                required: true,
                validator: (_, value, callback) => {
                  if (!value) {
                    callback(this.$t('请输入火警自复位时间'));
                  } else if (value > 250 || value < 1) {
                    callback(this.$t('火警自复位时间1-250秒之间'));
                  } else {
                    callback();
                  }
                },
                trigger: 'blur'
              }
            ],
            stationNumber: [
              {
                required: true,
                validator: (_, value, callback) => {
                  if (!value) {
                    return callback(this.$t('请输入站号地址'));
                  } else if (value > 247 || value < 1) {
                    return callback(this.$t('火警自复位时间1-247秒之间'));
                  } else {
                    callback();
                  }
                },
                trigger: 'blur'
              }
            ]
          }
        }
      };
    },
    methods: {
      async initParams() {
        try {
          this.loading = true;
          const res = await getFR01DeviceData({ sn });

          res.data.forEach(e => {
            this.formConfig.model[e.itemCode] = e.itemValue;
          });

          this.rawData = res.data;
        } catch (error) {
          this.$message.error('获取设备参数失败');
          console.log(error);
        }
        this.loading = false;
      },
      async setDeviceParams() {
        try {
          await this.$refs.formRef.validate();

          this.rawData.forEach(e => {
            e.itemValue = this.formConfig.model[e.itemCode];
          });

          await setFR01DeviceParams({ fr01DeviceInfoItemValueList: this.rawData, sn });

          this.$message({
            type: 'success',
            message: this.$t('修改成功'),
            showClose: true
          });

          this.cancel();
        } catch (error) {
          this.$message({
            type: 'error',
            message: this.$t('修改失败'),
            showClose: true
          });
          console.log(error);
        }
      },
      cancel() {
        this.$refs.dialogRef.beforeClose();
      }
    },
    mounted() {
      this.initParams();
    },
    render() {
      return (
        <NDialog ref="dialogRef" width="70vw" title={this.$t('设置设备参数')}>
          <div
            style="min-height: 50vh;"
            v-loading={this.loading}
            element-loading-text={this.$t('数据加载中')}
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
          >
            <MForm ref="formRef" props={this.formConfig} />
          </div>

          <div slot="footer">
            <el-button
              type="primary"
              loading={this.loading || this.saveLoading}
              onClick={this.setDeviceParams}
            >
              {this.$t('save')}
            </el-button>
            <el-button onClick={this.cancel}>{this.$t('取消')}</el-button>
          </div>
        </NDialog>
      );
    }
  });

  component.$mount();
}

export function openFR01BoxParamsSettingsWindow({ sn }) {
  const component = useComponent({
    components: { NDialog, MForm },
    data() {
      return {
        name: '',
        loading: false,
        saveLoading: false,
        rawData: null,
        formConfig: {
          i18nPath: 'part',
          config: {
            i18nPath: 'cotton',
            labelWidth: '183px',
            span: 12,
            options: [
              {
                type: 'input',
                label: '下行端口:',
                prop: 'downlinkPort',
                attrs: {
                  min: 1,
                  max: 65535,
                  type: 'number'
                }
              },
              {
                prop: 'pollingContent',
                label: '轮训包内容:',
                type: 'input'
              },
              {
                prop: 'pollingCycle',
                label: '轮训周期:',
                type: 'input',
                attrs: {
                  type: 'number'
                },
                slots: {
                  append: () => {
                    return <span>秒</span>;
                  }
                }
              },
              {
                type: 'input',
                label: '端口波特率:',
                prop: 'portBaudRate',
                attrs: {
                  type: 'number'
                }
              },
              // {
              //   type: 'input',
              //   label: '端口描述:',
              //   prop: 'portDesc',
              //   attrs: {
              //     // activeColor: '#13ce66',
              //     // inactiveColor: '#ff4949',
              //     activeValue: '1',
              //     inactiveValue: '2',
              //     activeText: '自动',
              //     inactiveText: '不自动'
              //   }
              // },
              {
                prop: 'powerEnable',
                label: '端口输出电源:',
                type: 'switch',
                attrs: {
                  activeValue: 1,
                  inactiveValue: 0,
                  activeText: '开',
                  inactiveText: '关'
                }
              }
            ]
          },
          model: {
            sn,
            downlinkPort: 0,
            pollingContent: '',
            pollingCycle: 0,
            portBaudRate: 0,
            // portDesc: '',
            powerEnable: 0
          },
          dataSource: {},
          rules: {}
        }
      };
    },
    methods: {
      async initParams() {
        try {
          this.loading = true;
          const res = await getFr01BoxConfigBySn(sn);

          const config = res.data.configParams.config;

          Object.assign(this.formConfig.model, {
            downlinkPort: config.downlinkPort,
            pollingContent: config.pollingContent,
            pollingCycle: config.pollingCycle,
            portBaudRate: config.portBaudRate,
            // portDesc: config.portDesc,
            powerEnable: config.powerEnable
          });
        } catch (error) {
          this.$message.error('获取设备参数失败');
          console.log(error);
        }
        this.loading = false;
      },
      async setDeviceParams() {
        try {
          await this.$refs.formRef.validate();

          const model = this.formConfig.model;

          await setFr01BoxConfigBySn({
            downlinkPort: +model.downlinkPort,
            pollingContent: model.pollingContent,
            pollingCycle: +model.pollingCycle,
            portBaudRate: +model.portBaudRate,
            // portDesc: '',
            powerEnable: +model.powerEnable,
            sn
          });

          this.$message({
            type: 'success',
            message: this.$t('修改成功'),
            showClose: true
          });

          this.cancel();
        } catch (error) {
          this.$message({
            type: 'error',
            message: this.$t('修改失败'),
            showClose: true
          });
          console.log(error);
        }
      },
      cancel() {
        this.$refs.dialogRef.beforeClose();
      }
    },
    mounted() {
      this.initParams();
    },
    render() {
      return (
        <NDialog ref="dialogRef" width="70vw" title={this.$t('设置设备参数')}>
          <div
            style="min-height: 50vh;"
            v-loading={this.loading}
            element-loading-text={this.$t('数据加载中')}
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
          >
            <MForm ref="formRef" props={this.formConfig} />
          </div>

          <div slot="footer">
            <el-button
              type="primary"
              loading={this.loading || this.saveLoading}
              onClick={this.setDeviceParams}
            >
              {this.$t('save')}
            </el-button>
            <el-button onClick={this.cancel}>{this.$t('取消')}</el-button>
          </div>
        </NDialog>
      );
    }
  });

  component.$mount();
}

export function openDeviceInfoPopover(deviceInfo) {
  if (!isObject(deviceInfo)) return;

  const data = {
    props: {
      title: '设备信息',
      width: '400px',
      height: '230px'
    },
    onEdit: () => {
      setDeviceCoordinate({
        wrapClassName: ['position-dialog-wrap'],
        container: document.querySelector('.cotton-home'),
        deviceInfo
      });
    }
  };

  const compo = useComponent({
    data() {
      return {
        timer: null,
        model: {
          ...deviceInfo,
          currentVersion: '',
          latestVersion: '',
          state: 0,
          offset: 0,
          fileLength: 0
        },
        list: [
          {
            label: '设备号',
            prop: 'sn'
          },
          {
            label: '设备名称',
            prop: 'name'
          },
          // {
          //   label: '硬件版本',
          //   prop: 'hardwareVersion'
          // },
          {
            label: '固件版本',
            prop: 'currentVersion'
          }
        ]
      };
    },
    computed: {
      isLatest() {
        return this.model.currentVersion === this.model.latestVersion;
      },
      isUpdating() {
        return [1, 2].includes(this.model.state);
      },
      versionInfoText() {
        const { state, offset, fileLength } = this.model;

        if (this.isLatest) return '已经是最新版本';

        const stateDict = {
          1: () => `更新中(${Number((offset / fileLength) * 100).toFixed(2)}%)`,
          2: () => '安装中...',
          3: () => '升级中',
          4: () => `升级至版本${this.model.latestVersion}失败, 点击重试`
        };

        if (state in stateDict) {
          return stateDict[state]();
        }

        return `固件最新版本: ${this.model.latestVersion}, 点此处进行更新`;
      }
    },
    methods: {
      async getDeviceUpgradeInfo(sn) {
        const res = await getDeviceUpgradeParams(sn);

        const { code, data } = res;

        if (code !== 200) return this.$message.error('获取设备信息失败');

        Object.assign(this.model, {
          ...data,
          latestVersion: data.latestVersion || data.currentVersion
        });
      },
      async updateDeviceFirmareVersion(sn) {
        if (this.isLatest || this.isUpdating) return;

        try {
          const res = await upgradeDevice(sn);

          if (res.code !== 200) return;

          this.enableUpdateInterval(true);
        } catch (error) {
          console.log(error);
          this.$message.error('升级失败');
        }
      },
      enableUpdateInterval(immediate) {
        clearInterval(this.timer);

        this.timer = setInterval(
          () => {
            this.getDeviceUpgradeInfo(this.model.sn);
          },
          immediate ? 300 : 5000
        );
      }
    },
    watch: {
      isUpdating(state) {
        if (state) {
          this.enableUpdateInterval();
        } else {
          clearInterval(this.timer);
        }
      }
    },
    mounted() {
      this.getDeviceUpgradeInfo(this.model.sn);
    },
    beforeDestroy() {
      clearInterval(this.timer);
    },
    render() {
      const { model, list, versionInfoText } = this;

      const items = list.map(e => (
        <div style="display:flex; justify-content: center;margin: 5px;">
          <span style="width: 65px;text-align-last: justify;margin-right:5px;">{e.label}: </span>
          <span style="width: 140px">{model[e.prop]}</span>
        </div>
      ));

      const content = (
        <div style="display: flex; flex-direction: column; align-items: center;">
          {items}
          <el-link
            type="primary"
            style="margin-top: 15px; color: #7AD7FC;"
            onClick={() => this.updateDeviceFirmareVersion(model.sn)}
          >
            {versionInfoText}
          </el-link>
        </div>
      );

      return (
        <MInfoWindow props={data.props} onEdit={data.onEdit}>
          {content}
        </MInfoWindow>
      );
    }
  });

  compo.$mount();
}

export function openCompanyListPopover(list) {
  const component = useComponent({
    components: { MPopover },
    data() {
      return {};
    },
    render() {
      const companyList = list.map(e => <li>{e.name}</li>);

      return (
        <MPopover>
          <div>切换公司</div>
          <ul>{companyList}</ul>
        </MPopover>
      );
    }
  });

  component.$mount();
}
